<template>
  <div class="py-4 container-fluid">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "rawMaterialIndex",
};
</script>
